<template>
  <div class="modal-footer-wallet">
    <div v-if="!showLoading">
      <ModalButton
        v-if="showLeftButton"
        class="modal-footer-wallet__button"
        @click="leftButtonClicked"
      >
        {{ leftButtonLabel }}
      </ModalButton>
      <ModalButton
        v-if="showRightButton"
        class="modal-footer-wallet__button"
        @click="rightButtonClicked"
      >
        {{ rightButtonLabel }}
      </ModalButton>
    </div>
    <ButtonIconContextual
      v-else
      label="Carregando"
      aria-label="Carregando"
      icon="EF0010"
      :loading="true"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { ModalButton, ButtonIconContextual } from '@warrenbrasil/nebraska-web';

@Component({
  components: { ModalButton, ButtonIconContextual }
})
export default class ModalFooterWallet extends Vue {
  @Prop({ type: String, required: true })
  readonly leftButtonLabel!: string;

  @Prop({ type: String, default: 'Fechar' })
  readonly rightButtonLabel!: string;

  @Prop({ type: Boolean, default: false })
  readonly disabledLeftButton!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly disabledRightButton!: boolean;

  @Prop({ type: Boolean, default: true })
  readonly showRightButton!: boolean;

  @Prop({ type: Boolean, default: true })
  readonly showLeftButton!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly showLoading!: boolean;

  @Emit('left-button-clicked')
  public leftButtonClicked() {}

  @Emit('right-button-clicked')
  public rightButtonClicked() {}
}
</script>

<style lang="less" scoped>
.modal-footer-wallet {
  display: flex;
  justify-content: center;
  padding: @size-spacing-x350 @size-spacing-x500;
  background: @background-primary;

  div {
    width: 100%;
  }

  &__button {
    width: 100%;
  }
}
</style>
